// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_home_home_module_ts":"ddbfc0552fa4674d","src_app_modules_metadata-catalogs_metadata-catalogs_module_ts":"587f89a9c4c23e59"}[chunkId] + ".js";
};